import { ajaxSend } from 'api/api';

import type { AvailableCountriesGetItemsResponse } from './types';

export const getAvailableCountries = () => {
  return ajaxSend<AvailableCountriesGetItemsResponse>({
    path: '/v1/available-countries',
  });
};
